module.exports = __webpack_public_path__ + "img/triangle-exclamation.1e485deb.svg";